import styles from "./backgroundImage.module.scss";

interface BackgroundImageProps {
  className?: string;
  radial?: boolean;
}

export function BackgroundImage({ className, radial }: BackgroundImageProps) {
  // Изображения предзагружаются через imagePreloader при старте приложения
  // Браузер автоматически использует кеш при загрузке через img src
  const imageSrc = radial ? "/assets/ambient-radial.webp" : "/assets/ambient.webp";

  return (
    <img
      src={imageSrc}
      alt=""
      className={`${styles.image}${className ? ` ${className}` : ""}`}
    />
  );
}

